import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockData } from '../mockData';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../components/ui/carousel';

export const HelicalDetail = () => {
  const { language } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const helicalMachines = mockData.catalogItems.filter(item => item.category === 'Helezon');

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {language === 'tr' ? 'Helezon (Vida) Sistemleri' : 'Helical (Screw) Systems'}
          </h1>
          <p className="text-xl text-gray-600">
            {language === 'tr' 
              ? 'Toz, granül ve parçacıklı malzemelerin taşınması için paslanmaz çelik helezon sistemleri. Özel ölçü ve tasarım imkanı.'
              : 'Stainless steel helical systems for transporting powder, granules and particulate materials. Custom size and design options available.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {helicalMachines.map((machine) => (
            <div
              key={machine.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-80">
                {machine.images && machine.images.length > 1 ? (
                  <Carousel className="w-full h-full">
                    <CarouselContent>
                      {machine.images.map((image, idx) => (
                        <CarouselItem key={idx}>
                          <div 
                            className="h-80 cursor-pointer"
                            onClick={() => setSelectedImage(image)}
                          >
                            <img
                              src={image}
                              alt={`${machine.title} - ${idx + 1}`}
                              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                            />
                          </div>
                        </CarouselItem>
                      ))}
                    </CarouselContent>
                    <CarouselPrevious className="left-4" />
                    <CarouselNext className="right-4" />
                  </Carousel>
                ) : (
                  <div 
                    className="h-80 cursor-pointer overflow-hidden"
                    onClick={() => setSelectedImage(machine.images ? machine.images[0] : '')}
                  >
                    <img
                      src={machine.images ? machine.images[0] : ''}
                      alt={machine.title}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                )}
              </div>

              <div className="p-6">
                <div className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full mb-3">
                  {machine.category}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{machine.title}</h3>
                <p className="text-gray-600 mb-4">{machine.description}</p>
                {machine.images && machine.images.length > 1 && (
                  <p className="text-sm text-blue-600 font-semibold">
                    {language === 'tr' 
                      ? `${machine.images.length} fotoğraf - Kaydırarak görün` 
                      : `${machine.images.length} photos - Swipe to view`}
                  </p>
                )}
                <p className="mt-2 text-blue-700 font-semibold">
                  {language === 'tr' ? 'Fotoğrafı büyütmek için tıklayın' : 'Click to enlarge photo'}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Simple Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
          >
            <X size={40} />
          </button>
          <img
            src={selectedImage}
            alt="Büyük Görünüm"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};
